import { useTranslation } from 'react-i18next';
import TopDealerClickEvent from 'lib/Tracking/Srp/TopDealerClickEvent';
import eventLogger from 'lib/EventLogger';
import { TopDealers as TopDealersType } from 'lib/AutolistAPI';
import { styles } from './styles';

export default function TopDealers({
  dealers,
  locationDisplayName,
}: {
  dealers: TopDealersType;
  locationDisplayName?: string;
}): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="link-bank-container">
      <div className="link-bank-title">{`${t('seoSrp.topDealers')} ${locationDisplayName}`}</div>
      <div className="links-container">
        {dealers.map((dealer, index) => (
          <div className="link-container" key={dealer.url}>
            <a
              className="link"
              href={`dealers/${dealer.url}`}
              tabIndex={index}
              onClick={(): Promise<void> => eventLogger.log(TopDealerClickEvent())}
            >
              {dealer.title}
            </a>
          </div>
        ))}
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}
